import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../hooks/redux';
import { SetNewPasswordForm } from '../../forms/SetNewPasswordFrom';
import { userInfoApi } from '../../../services/apiServices/user/userInfo';
import { modalSlice } from '../../../store/reducers/ModalSlice';
import { useCustomSnackbar } from '../../../hooks/useCustomEnqueueSnackbar';
import { ModalVariants } from '../../../models/Common';

interface NewPassword {
  password: string;
  passwordConfirmation: string;
  currentPassword: string;
}

export const Password: FC = () => {
  const { t } = useTranslation();
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const [setNewPassword, { isLoading }] = userInfoApi.useSetNewAccountPasswordMutation();
  const dispatch = useAppDispatch();
  const { openModal } = modalSlice.actions;

  const submitNewPassword = async ({ password, passwordConfirmation, currentPassword }: NewPassword) => {
    return setNewPassword({ password, passwordConfirmation, currentPassword })
      .unwrap()
      .then(() => {
        customEnqueueSnackbar(t('snackbar.passwordSuccessfullyChanged'), 'success');
      });
  };

  const handleForgotPassword = () => {
    dispatch(openModal({ modalVariants: ModalVariants.LogOut }));
  };

  return (
    <div className="password">
      <div className="password__form-container">
        <article className="password__form-container__title">{t('auth.enterNewPassword')}</article>
        <SetNewPasswordForm
          submitNewPassword={submitNewPassword}
          buttonText={t('buttons.saveChanges')}
          isLoading={isLoading}
          handleForgotPassword={handleForgotPassword}
        />
      </div>
    </div>
  );
};
